import { Box, Divider, Stack } from '@mui/material';
import { t } from 'i18next';
import { FormEventHandler } from 'react';
import { useFormItem } from '../../../common/hooks/use-form-item';
import { InputType } from '../../../common/hooks/use-form-item/types';
import { and } from '../../../common/hooks/use-form-item/validators/compositions';
import { required } from '../../../common/hooks/use-form-item/validators/existential';
import { maxLength } from '../../../common/hooks/use-form-item/validators/operational';
import { url, urlWithoutTrailingSlash } from '../../../common/hooks/use-form-item/validators/type';
import { ButtonBox, PrimaryButton } from '../../../modal-flows/components/Buttons';

type Props = {
  jiraUrl: string;
  handleClickNext: (newUrl: string) => void;
};

export const JiraUrlForm = ({ jiraUrl, handleClickNext }: Props) => {
  const [baseUrl, baseUrlComponent, isBaseUrlValid] = useFormItem<string>({
    type: InputType.TYPE_TEXT,
    label: t('jiraIssueExport.baseUrlInputLabel'),
    value: jiraUrl || '',
    validator: and(required(), url(), urlWithoutTrailingSlash(), maxLength(1000)),
    inputOptions: {
      autoFocus: true,
      showRequiredIndicator: true,
      sx: { width: '60%' },
    },
    textOptions: { trimOnBlur: true },
  });

  const canSubmit = !!baseUrl && isBaseUrlValid;

  const onSubmit: FormEventHandler = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    handleClickNext(baseUrl);
  };

  return (
    <Stack sx={{ height: '100%', justifyContent: 'space-between' }} component="form" onSubmit={onSubmit}>
      {baseUrlComponent}
      <Box>
        <Divider textAlign="center" />
        <ButtonBox>
          <PrimaryButton disabled={!canSubmit} type="submit">
            {t('jiraIssueExport.next')}
          </PrimaryButton>
        </ButtonBox>
      </Box>
    </Stack>
  );
};
